import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

const ActionConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Confirm",
  danger = false,
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="small">
      <Modal.Header title={title} />
      <Modal.Body>
        <p className="text-gray-600">{message}</p>
      </Modal.Body>
      <Modal.Footer
        onClose={onClose}
        onSubmit={onConfirm}
        confirmBtnText={confirmLabel}
        confirmBtnVariant={danger ? "danger" : "primary"}
        confirmBtnLoading={isLoading}
      />
    </Modal>
  )
}

ActionConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  danger: PropTypes.bool,
  isLoading: PropTypes.bool,
}

export default ActionConfirmModal
